import React, { Component } from "react";
import {
  Col,
  Button,
  Input,
  Table,
  UncontrolledTooltip,
  Alert,
  FormGroup
} from "reactstrap";
import {
  sortableContainer,
  sortableElement,
  sortableHandle
} from "react-sortable-hoc";
import { courses } from "../../../../redux/actions/courses";
import arrayMove from "array-move";
import { forOwn, find } from "mout/object";
import sortByPropText from "../../../../helpers/content/manageSets/sortByPropText";
import SectionCollapsable from "../AuthorCollapsable/SectionCollapsable";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import { PulseLoader } from "react-spinners";
import LessonCard from "../LessonCard";
import { connect } from "react-redux";
import LessonCollapsable from "../AuthorCollapsable/LessonCollapsable";

const SortableItem = sortableElement(
  ({
    value,
    toggle,
    toggleCard,
    index,
    type,
    lastItem,
    onSortEnd,
    reArrange,
    addLesson,
    section,
    updateLessonIndex
  }) => (
    <LessonCollapsable
      updateLessonIndex={updateLessonIndex}
      section={section}
      addLesson={addLesson}
      reArrange={reArrange}
      onSortEnd={onSortEnd}
      lastItem={lastItem}
      index={index}
      type={type}
      toggleCard={toggleCard}
      toggle={toggle}
      value={value}
    />
  )
);
const SortableContainer = sortableContainer(({ children }) => {
  return <tbody>{children}</tbody>;
});

class SectionManage extends Component {
  state = {
    items: [],
    diff: [],
    toggle: false,
    toggleValue: "",
    addSection: false,
    reArrange: false
  };
  componentDidMount() {
    //replace the function wiht getSubcourse
    this.props.getLesson("3dbe15a0-56f3-11e9-b6fb-8bb2f92a2ba5");
    this.props.getSection("ef223ab0-5649-11e9-958b-a7194ee37ab0");
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.courses.sectionLessons[
        "3dbe15a0-56f3-11e9-b6fb-8bb2f92a2ba5"
      ] &&
      this.state.items.length === 0
    ) {
      const { courses, value } = this.props;
      if (courses.subcourseSections["ef223ab0-5649-11e9-958b-a7194ee37ab0"]) {
        let lessons =
          courses.subcourseSections["ef223ab0-5649-11e9-958b-a7194ee37ab0"];
        let allLessons =
          courses.sectionLessons["3dbe15a0-56f3-11e9-b6fb-8bb2f92a2ba5"];
        let section = find(lessons, {
          id: "3dbe15a0-56f3-11e9-b6fb-8bb2f92a2ba5"
        });

        let items = [];

        forOwn(section.lessons, function(val, key) {
          allLessons.forEach(section => {
            if (section.id === key) {
              let obj = {
                ...section,
                index: val
              };
              items.push(obj);
            }
          });
        });
        this.setState({ items: sortByPropText(items, "index"), section: section});
      }
    }
  }

  updateLessonIndex = (id, index) => {
    this.setState(state => {
      let arr = Array.from(state.diff);
      arr.push({ id, index });
      return { diff: arr };
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex)
    }));
    if (this.state.diff.length > 0) {
      this.props.updateIndexLesson(this.state.section.id, this.state.diff);
      this.setState({ diff: [] });
    }
  };

  reArrangeLesson = () => {
    this.setState(state => ({ reArrange: !state.reArrange }))
    //this.toggleLesson()
}
addLesson = () => {
    this.setState(state => ({ addLesson: !state.addLesson, collapse: true }))
}
  render() {
    const { items, addSection, reArrange, addLesson, section } = this.state;
    const value = section;
    console.log(items)
    return (
      <React.Fragment>
        <Col colSpan="6" md="6" sm="12">
          {value ? <LessonCard
            iconClass="items-icon"
            heading="View and Manage Lessons"
            isCollapsable={true}
            headerButtons={[
              <Button className="icon-btn">
                <i className="icon-preview-icon" />
              </Button>
            ]}
          >
            <div className="filter-input">
              <Input
                type="text"
                name="filter-input"
                placeholder="Search"
              />
            </div>

            <div className="course-sortable-container author-course-edit">
              <div className="course-list-items">
                <div className={`draggable-row  mt-3`}>
                  <span className="draggable-row-text text-subcourse mr-1">
                    ACT Mastery English
                  </span>
                  <ul
                    className="mb-0"
                    style={{ listStyle: "none", marginTop: "8px" }}
                  >
                    <li>
                      <span className="draggable-row-text text-subcourse mr-1">
                        Challenger
                        {/* {value.name}  */}
                      </span>
                      <span className="draggable-row-text text-subcourse mr-1">
                        [
                        {(items.length > 0 && items.length) ||
                          `${
                            !!Object.values(value.lessons).filter(
                              index => index !== "-1"
                            ).length
                              ? Object.values(value.lessons).filter(
                                  index => index !== "-1"
                                ).length
                              : 0
                          }`}
                        ]
                      </span>
                      <span
                        onClick={this.reArrangeLesson}
                        id={`tooltip-${value.id}-rearrange`}
                        className={`${
                          reArrange ? "active" : ""
                        } rearrange-icon draggable-title-icons mx-1`}
                      />
                      <i
                        id={`tooltip-${value.id}-new`}
                        onClick={this.addLesson}
                        className="draggable-title-icons mx-1 add-contents-icon"
                      />
                      <UncontrolledTooltip
                        target={`tooltip-${value.id}-rearrange`}
                      >
                        Rearrange Lessons
                      </UncontrolledTooltip>
                      <UncontrolledTooltip target={`tooltip-${value.id}-new`}>
                        Add New Lesson
                      </UncontrolledTooltip>
                    </li>
                  </ul>
                </div>
                <Table
                  striped
                  size="sm"
                  className="edit-lesson-table"
                  style={{ paddingLeft: "40px" }}
                >
                  <thead>
                    <tr>
                      {reArrange && <th style={{ width: "25px" }} />}
                      <th style={{ width: "80px" }}>
                        Order
                        <i
                          className="arrow-down ml-2"
                          onClick={() => this.sortData("index")}
                        />
                      </th>
                      {reArrange && <th style={{ width: "25px" }} />}
                      {reArrange && <th style={{ width: "25px" }} />}
                      {reArrange && <th style={{ width: "25px" }} />}
                      <th>
                        <i className="lesson-icon mr-2" />
                        Lesson Name
                        <i
                          onClick={() => this.sortData("name")}
                          className="arrow-down ml-2"
                        />
                      </th>
                      <th>
                        <i className="deck-icon mr-2" />
                        Decks
                        <i className="arrow-down ml-2" />
                      </th>
                      <th>
                        <i className="items-icon mr-2" />
                        Items
                        <i className="arrow-down ml-2" />
                      </th>
                      <th>
                        <i className="rules-icon mr-2" />
                        Rules
                        <i className="arrow-down ml-2" />
                      </th>
                    </tr>
                  </thead>
                  {items.length > 0 ? (
                    <SortableContainer
                      lockToContainerEdges
                      lockAxis={"y"}
                      helperClass={"dragging-lesson"}
                      shouldCancelStart={this.shouldCancelStart}
                      distance={1}
                      useDragHandle
                      onSortEnd={this.onSortEnd}
                    >
                      {items.map((item, index) => (
                        <SortableItem
                          updateLessonIndex={this.updateLessonIndex}
                          addLesson={addLesson}
                          reArrange={reArrange}
                          toggleCard={this.props.toggleCard}
                          onSortEnd={this.onSortEnd}
                          toggle={this.props.toggle}
                          key={`item-${index}`}
                          section={value}
                          index={index}
                          type={'section'}
                          lastItem={items.length}
                          value={item}
                        />
                      ))}
                    </SortableContainer>
                  ) : (
                    <tbody>
                      {
                        <tr className="new-item-section scroll-to-lesson">
                          <td colSpan={reArrange ? 5 : 1} />
                          <td className="p-2 subcourse-head">Add new Lesson</td>
                          <td colSpan="2" sm="9">
                            <Input
                              value={this.state.name}
                              onChange={this.handleChange}
                              placeholder={"Enter Lesson Name .."}
                            />
                          </td>
                          <td colSpan="1" sm="3" className="pl-0">
                            <Button
                              className="w-100"
                              disabled={this.state.name === ""}
                              onClick={this.submit}
                            >
                              {courses.creatingLesson ? (
                                <div className="m-auto">
                                  <PulseLoader
                                    loading
                                    color={"#fff"}
                                    size={10}
                                  />
                                </div>
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </LessonCard> : ''}
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    courses: state.courses
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSection: subcourseId => {
      dispatch(courses.getSection(subcourseId));
    },
    getLesson: sectionId => {
      dispatch(courses.getLesson(sectionId));
    },
    updateIndexLesson: (sectionId, indexes) => { 
        dispatch(courses.updateIndexLesson(sectionId, indexes)) 
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionManage);



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSection/SectionManage.js